import { isEmpty, isObject } from "lodash";

export const hasTruthyValues = (value: unknown): boolean => {
  if (isObject(value)) {
    if (isEmpty(value)) return false;
    return Object.values(value as Record<string, unknown>).every(val =>
      hasTruthyValues(val),
    );
  }

  return Boolean(value);
};
